import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { RulesTabsComponent } from './rules-tabs.component';
import { RulesComponent } from './rules.component';

@Component({
    selector: 'aw-rules-container',
    templateUrl: './rules-container.component.html',
    styleUrls: ['./rules-container.component.less'],
    imports: [RulesTabsComponent, RulesComponent]
})
export class RulesContainerComponent implements OnInit {
    selectedStepId: string = "";
    environmentalIndicatorDetailStep: string = 'EnvironmentalIndicatorDetail';

    constructor(
        private route: ActivatedRoute
    ) {
    }

    ngOnInit(): void {
        this.route.queryParams.pipe(filter(params => params.stepId))
            .subscribe(params => {
                this.selectedStepId = params.stepId;
            })
    }

    showTabs(): boolean {
        return this.selectedStepId === this.environmentalIndicatorDetailStep;
    }
}